import { connect } from 'react-redux';
import { compose } from 'redux';
import selectors from '../../../rootSelectors';
import { goTo } from '../../../common/navigation/navigationActions';
import { narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { unmountScreen } from '../../../common/screen/screenActions';
import { setCompletedStepIndex, narrateScreen, setCurrentStepIndex } from '../../trcActions';
import { TRC_BOOK_START } from '../../../constants/url';
import { getTrcInstruction, getTrcCaption } from '../../troConstants';
import TRORemindersView from './TRORemindersView';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';

const trcRemindersInstruction = 'trcReminders';

const mapStateToProps = (state) => {
    const isExternalURLSourcePresent = selectors.getExternalURLSourceStatus(state);
    const arLanguage = selectors.getArLanguage(state);
    const instructions = getTrcInstruction(isExternalURLSourcePresent, trcRemindersInstruction, arLanguage);
    return {
        instructions,
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        onboardingProgressBar: selectors.getOnboardingProgressBar(state),
        isExternalURLSourcePresent,
    };
};

const mapDispatchToProps = (dispatch) => ({
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
    },
    goToNextPage: () => dispatch(goTo(TRC_BOOK_START)),
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const reminders = getTrcInstruction(isExternalURLSourcePresent, trcRemindersInstruction, arLanguage);
        const caption = getTrcCaption(isExternalURLSourcePresent, trcRemindersInstruction, arLanguage);
        dispatch(narrateScreen(reminders, caption));
    },
    setCompletedStepIndex: stepIndex => dispatch(setCompletedStepIndex(stepIndex)),
    setCurrentStepIndex: stepIndex => dispatch(setCurrentStepIndex(stepIndex)),
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(TRORemindersView);
